export const API_URL = "/api/";
export const EXCEL_FILE_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export const PDF_FILE_TYPE = "application/pdf";
